<template>
  <div>
    <div style="overflow-x: auto; white-space: nowrap">
      <template v-for="option in dateOptions">
        <v-btn
          :key="option.value"
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="filter != option.value"
          :color="filter == option.value ? 'primary' : 'grey'"
          small
          @click="changeDate(option.value)"
          >{{ option.text }}</v-btn
        >
      </template>
    </div>

    <div class v-if="filter == 'custom_date' || filter == 'custom_time'">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <span>{{ $t('from') }}:</span>
          <v-layout>
            <v-flex :xs12="!showTime" :x8="showTime" class=" pa-1">
              <date-picker color="primary" v-model="date.startdate">
                <template v-slot="{ computedDate }">
                  <v-text-field
                    :data-vv-as="$t('from')"
                    :value="computedDate"
                    readonly
                    placeholder="DD/MM/YYYY"
                    hide-details
                    outline
                    single-line
                    label=""
                  ></v-text-field>
                </template>
              </date-picker>
            </v-flex>
            <v-flex v-if="showTime" xs4 class=" pa-1">
              <time-picker v-model="date.starttime" color="primary">
                <v-text-field
                  :data-vv-as="$t('time')"
                  v-model="date.starttime"
                  readonly
                  placeholder="00:00"
                  hide-details
                  outline
                  single-line
                  label=""
                >
                </v-text-field>
              </time-picker>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
          <span>{{ $t('to') }}:</span>
          <v-layout wrap>
            <v-flex :xs12="!showTime" :xs8="showTime" class=" pa-1">
              <date-picker v-model="date.enddate" color="primary" hide-details>
                <template v-slot="{ computedDate }">
                  <v-text-field
                    :data-vv-as="$t('to')"
                    :value="computedDate"
                    readonly
                    placeholder="DD/MM/YYYY"
                    hide-details
                    outline
                    single-line
                    rounded
                    dense
                  >
                  </v-text-field>
                </template>
              </date-picker>
            </v-flex>
            <v-flex v-if="showTime" xs="4" class=" pa-1">
              <time-picker v-model="date.endtime" color="primary">
                <v-text-field
                  :data-vv-as="$t('time')"
                  v-model="date.endtime"
                  readonly
                  placeholder="00:00"
                  hide-details
                  outline
                  single-line
                  rounded
                  dense
                >
                </v-text-field>
              </time-picker>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs="12" class="text-xs-right pa-1">
          <v-btn color="primary" small @click="onSearch">{{ $t('Search') }}</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import DatePicker from './DatePicker.vue'
import TimePicker from './TimePicker.vue'
import { cloneDeep } from 'lodash'
export default {
  components: { DatePicker, TimePicker },
  props: {
    value: {
      default: {
        start: null,
        end: null
      }
    },
    currentFilter: {
      default: 'today'
    },
    availableOptions: {
      default: 'past'
    },
    showTime: {
      default: false
    }
  },
  computed: {
    dateOptions() {
      var options = [
        {
          value: 'today',
          text: this.$t('today'),
          type: 'now'
        },
        {
          value: 'yesterday',
          text: this.$t('yesterday'),
          type: 'past'
        },
        {
          value: 'last_3_days',
          text: this.$t('last {day} days', { day: 3 }),
          type: 'past'
        },
        {
          value: 'last_7_days',
          text: this.$t('last {day} days', { day: 7 }),
          type: 'past'
        },
        {
          value: 'last_15_days',
          text: this.$t('last {day} days', { day: 15 }),
          type: 'past'
        },
        {
          value: 'last_month',
          text: this.$t('last {day} days', { day: 30 }),
          type: 'past'
        },
        {
          value: 'last_365_day',
          text: this.$t('last {day} days', { day: 365 }),
          type: 'past'
        },
        // future
        {
          value: 'tomorrow',
          text: this.$t('tomorrow'),
          type: 'future'
        },
        {
          value: 'next_3_days',
          text: this.$t('next {day} days', { day: 3 }),
          type: 'future'
        },
        {
          value: 'next_7_days',
          text: this.$t('next {day} days', { day: 7 }),
          type: 'future'
        },
        {
          value: 'this_month',
          text: this.$t('this month'),
          type: 'now'
        },
        {
          value: 'this_year',
          text: this.$t('this year'),
          type: 'now'
        },
        {
          value: 'custom_date',
          text: this.$t('Custom Date'),
          type: 'custom_date'
        }
      ]
      if (this.availableOptions == 'past') {
        return options.filter(el => {
          return ['now', 'past', 'custom_date'].includes(el.type)
        })
      }
      if (this.availableOptions == 'future') {
        return options.filter(el => {
          return ['now', 'future', 'custom_date'].includes(el.type)
        })
      } else if (this.availableOptions != '') {
        return options.filter(el => {
          return this.availableOptions.includes(el.value)
        })
      } else {
        return options
      }
    }
  },
  data() {
    return {
      filter: null,
      date: {
        startdate: null,
        enddate: null,
        starttime: null,
        endtime: null
      }
    }
  },
  mounted() {
    let start, end, filter
    if (this.$route.query.filter) {
      if (
        this.$route.query.filter == 'custom_date' &&
        this.$route.query.start &&
        this.$route.query.end
      ) {
        start = dayjs(this.$route.query.start, 'YYYY-MM-DD HH:mm')
        end = dayjs(this.$route.query.end, 'YYYY-MM-DD HH:mm')
      }
      filter = this.$route.query.filter
    } else if (!this.value) {
      if (this.currentFilter == 'custom_date' && this.value && this.value.start && this.value.end) {
        start = dayjs(this.value.start, 'YYYY-MM-DD HH:mm')
        end = dayjs(this.value.end, 'YYYY-MM-DD HH:mm')
      }
      filter = this.currentFilter
    }
    this.changeDate(filter)
    if (filter == 'custom_date') {
      this.date.startdate = start ? start.format('YYYY-MM-DD') : null
      this.date.enddate = end ? end.format('YYYY-MM-DD') : null
      this.date.starttime = start ? start.format('HH:mm') : null
      this.date.endtime = end ? end.format('HH:mm') : null
      this.emitDateTime()
    }
  },
  methods: {
    onSearch() {
      this.emitDateTime()
    },
    changeDate(value) {
      this.filter = value
      if (value != 'custom_date') {
        var date = {
          start: dayjs(),
          end: dayjs()
        }
        switch (value) {
          case 'today':
            break
          case 'yesterday':
            date.start = date.start.subtract(1, 'day')
            date.end = date.end.subtract(1, 'day')
            break
          case 'this_month':
            date.start = date.start.startOf('month')
            date.end = date.end.endOf('month')
            break
          case 'last_3_days':
            date.start = date.start.subtract(3, 'day')
            break
          case 'last_7_days':
            date.start = date.start.subtract(7, 'day')
            break
          case 'last_15_days':
            date.start = date.start.subtract(15, 'day')
            break
          case 'last_month':
            date.start = date.start.subtract(1, 'month')
            break
          case 'this_year':
            date.start = date.start.startOf('year')
            date.end = date.end.endOf('year')
            break
          case 'last_365_day':
            date.start = date.start.subtract(365, 'day')
            break
          case 'tomorrow':
            date.start = date.start.add(1, 'day')
            date.end = date.end.add(1, 'day')
            break
          case 'next_3_days':
            date.end = date.end.add(3, 'day')
            break
          case 'next_7_days':
            date.end = date.end.add(7, 'day')
            break
          case 'custom_date':
            break
        }
        if (this.filter != 'custom_date') {
          this.$set(this.date, 'startdate', date.start.format('YYYY-MM-DD 00:00'))
          this.$set(this.date, 'enddate', date.end.format('YYYY-MM-DD 23:59'))
          this.$set(this.date, 'starttime', '00:00')
          this.$set(this.date, 'endtime', '23:59')
        }
        this.emitDateTime()
      }
    },
    emitDateTime() {
      var data = {
        start:
          dayjs(this.date.startdate).format('YYYY-MM-DD') +
          (this.date.starttime && this.showTime
            ? ' ' + vm.formatTime(this.date.starttime)
            : ' 00:00'),
        end:
          dayjs(this.date.enddate).format('YYYY-MM-DD') +
          (this.date.endtime && this.showTime
            ? ' ' + vm.formatTime(this.date.endtime, { defaultHour: 23, defaultMinius: 59 })
            : ' 23:59')
      }
      this.$emit('input', data)
      this.$emit('changeDate', data)
      var query = cloneDeep(this.$route.query)

      if (this.filter == 'custom_date') {
        query = {
          ...query,
          ...data
        }
      }
      if (query.filter === this.filter) {
        try {
          this.$router.push({ query: query }).catch(() => {})
        } catch (error) {
          // console.log(error)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/DateSelecter.vue